import {Provider} from "react-redux";
import store from "./reducers/createReducers";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../src/i18n/i18n';
import React, {useEffect} from "react";
import LocationProtectedRoute from "./containers/LocationProtectedRoute";
import 'react-lazy-load-image-component/src/effects/blur.css';


function App() {
    useEffect(() => {
        // Display a big red "STOP" in the console
        console.log(
            "%cSTOP",
            "color: red; font-size: 50px; font-weight: bold;"
        );

        // Display the scam warning message
        console.log(
            "%cThis is a browser feature intended for developers. If someone told you to copy and paste something here to enable a This Website feature or 'hack' someone's account, it is a scam and will give them access to your This Website account.",
            "font-size: 20px; color: black; font-weight: bold;"
        );
    }, []);


    return (

        // <ErrorBoundary>
        <Provider store={store}>
            <LocationProtectedRoute/>

            <ToastContainer
                position="top-left"
                autoClose={10000}
                hideProgressBar={false}
                closeOnClick
                pauseOnFocusLoss={false}
                draggable
                pauseOnHover
            />
        </Provider>
        // </ErrorBoundary>

    )
}

export default App;
